import { render, staticRenderFns } from "./CallsignsAdmin.vue?vue&type=template&id=388cadb8&"
import script from "./CallsignsAdmin.vue?vue&type=script&lang=js&"
export * from "./CallsignsAdmin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports